// ------------------------------------------------------------- HERO CAROUSEL -----------------------------------------------------------------

class HeroCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') return;

    const swiperEl = this;
    if (!swiperEl) return;

    // Prevent double init
    if (this.swiper) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('hero-carousel', HeroCarousel);


// ------------------------------------------------------------- FEATURED COLLECTION ---------------------------------------------------------------

class FeaturedCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.warn('CollectionSwiper: Swiper not loaded');
      return;
    }

    if (this.swiper) return;

    const wrapper = this.querySelector('.swiper-wrapper');
    const navigation_container = this.previousElementSibling;

    if (!wrapper) {
      console.warn('CollectionSwiper: Missing .swiper-wrapper');
      return;
    }

    wrapper.classList.add('swiper-loaded-successfully');

    const config = {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,

      navigation: {
        nextEl: navigation_container.querySelector('.slider-button-next'),
        prevEl: navigation_container.querySelector('.slider-button-prev'),
      },

      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    };

    const scrollbar = this.querySelector('.swiper-scrollbar');
    if (scrollbar) {
      config.scrollbar = {
        el: scrollbar,
        draggable: true,
      };
    }

    this.swiper = new Swiper(this, config);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-carousel', FeaturedCarousel);

// ------------------------------------------------------------- COLLECTION SWIPER -----------------------------------------------------------------


class CollectionSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.warn('CollectionSwiper: Swiper not loaded');
      return;
    }

    if (this.swiper) return;

    const wrapper = this.querySelector('.swiper-wrapper');
    const navigation_container = this.previousElementSibling

    if (!wrapper) {
      console.warn('CollectionSwiper: Missing .swiper-wrapper');
      return;
    }

    wrapper.classList.add('swiper-loaded-successfully');

    const config = {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,

      navigation: {
        nextEl: navigation_container.querySelector('.slider-button-next'),
        prevEl: navigation_container.querySelector('.slider-button-prev'),
      },

      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    };

    const scrollbar = this.querySelector('.swiper-scrollbar');
    if (scrollbar) {
      config.scrollbar = {
        el: scrollbar,
        draggable: true,
      };
    }

    this.swiper = new Swiper(this, config);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('collection-swiper', CollectionSwiper);

// ------------------------------------------------------------- TESTIMONIAL CAROUSEL -------------------------------------------------------------

class TestimonialSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.log('Testimonials: Swiper not loaded, using grid fallback');
      return;
    }

    if (this.swiper) return;

    const swiperWrapper = this.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      // Reset grid fallback styles
      swiperWrapper.style.display = '';
      swiperWrapper.style.gridTemplateColumns = '';
      swiperWrapper.style.gap = '';
    }

    const scrollbarEl = this.querySelector('.swiper-scrollbar');

    const swiperConfig = {
      slidesPerView: 1.15,
      spaceBetween: 20,
      grabCursor: true,

      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },

      // 👇 Scrollbar ALWAYS enabled
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            dragSize: 'auto',
            hide: false,
          }
        : undefined,
    };

    this.swiper = new Swiper(this, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('testimonial-swiper', TestimonialSwiper);


// ------------------------------------------------------------- MEDIA CONTROLS -------------------------------------------------------------------


class MediaControls extends HTMLElement {
  constructor() {
    super();
    this.handleMediaToggle = this.handleMediaToggle.bind(this);
    this.handleMediaVolume = this.handleMediaVolume.bind(this);
    this.handleVideoEnd = this.handleVideoEnd.bind(this);
    this.handleAutoPlay = this.handleAutoPlay.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    // this.addEventListener("keydown", this.handleKeyDown);
    this.closest('.video-banner').querySelectorAll("video").forEach((video) => {
      if (!video.hasAttribute("loop")) {
        video.addEventListener("ended", this.handleVideoEnd);
      }
    });
    this.handleAutoPlay();
  }

  handleClick(event) {
    const button = event.target.closest("button");

    if (!button) return;

    if (button.classList.contains("media-toggle")) {
      this.handleMediaToggle(button);
    } else if (button.classList.contains("volume-toggle")) {
      this.handleMediaVolume(button);
    }
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      this.handleClick(event);
    }
  }

  handleMediaToggle(button) {
    let mediaContainer = this.closest(".video-banner");
    if (!mediaContainer) return;

    let videos = mediaContainer.querySelectorAll("video");
    let video = videos.length > 1 && window.matchMedia("(max-width: 768px)").matches ? videos[1] : videos[0];

    if (!video) return;

    if (video.paused) {
      video.play();
      button.classList.remove('paused');
    } else {
      video.pause();
      button.classList.add('paused');
    }
  }

  handleMediaVolume(button) {
    let mediaContainer = this.closest(".video-banner");
    if (!mediaContainer) return;

    let videos = mediaContainer.querySelectorAll("video");
    let video = videos.length > 1 && window.matchMedia("(max-width: 768px)").matches ? videos[1] : videos[0];

    if (!video) return;

    video.muted = !video.muted;

    button.classList.toggle("unmuted", !video.muted);
  }

  handleVideoEnd() {
    let toggleButton = this.querySelector(".media-toggle");
    if (toggleButton) {
      toggleButton.classList.add('paused');
    }
  }

  handleAutoPlay() {
    let mediaContainer = this.querySelector(".video-banner");
    if (!mediaContainer) return;

    let videos = mediaContainer.querySelectorAll("video");
    let video = videos.length > 1 && window.matchMedia("(max-width: 768px)").matches ? videos[1] : videos[0];

    if (!video) return;

    if(mediaContainer.dataset.autoplay === "true") {
      video.play();
    }
  }

}
customElements.define("media-controls", MediaControls);


// ------------------------------------------------------------- COLLECTION DESCRIPTION -----------------------------------------------------------

class CollectionDescription extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('.collection-description__content');
    const button = this.querySelector('.collection-description__toggle');
    const read_more_text = this.getAttribute('data-read-more');
    const read_less_text = this.getAttribute('data-read-less');


    if (!content || !button) return;

    // Store full HTML once
    const fullHTML = content.innerHTML;

    const blocks = Array.from(content.children);
    const preview = [];

    let pCount = 0;
    let hCount = 0;

    for (const el of blocks) {
      const tag = el.tagName.toLowerCase();

      if (/^h[1-6]$/.test(tag)) {
        preview.push(el.cloneNode(true));
        hCount++;
        continue;
      }

      if (tag === 'p') {
        preview.push(el.cloneNode(true));
        pCount++;
      }

      // Stop after:
      // h + p OR p + h + p
      if (
        (hCount >= 1 && pCount >= 1) ||
        (pCount >= 2 && hCount >= 1)
      ) {
        break;
      }
    }

    // Nothing to truncate → exit silently
    if (preview.length === blocks.length) return;

    // Render preview
    content.innerHTML = '';
    preview.forEach(el => content.appendChild(el));

    button.classList.remove('hidden');

    // Toggle behavior
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';

      content.innerHTML = expanded
        ? preview.map(el => el.outerHTML).join('')
        : fullHTML;

      button.setAttribute('aria-expanded', String(!expanded));
      button.querySelector('span').textContent = expanded
        ? button.dataset.readMore || read_more_text
        : button.dataset.readLess || read_less_text

      if (expanded) {
        const rect = content.getBoundingClientRect();

        const y =
          rect.top +
          window.pageYOffset -
          (window.innerHeight / 2) +
          (rect.height / 2);

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });

        content.setAttribute('tabindex', '-1');
        content.focus({ preventScroll: true });

        content.addEventListener(
          'blur',
          () => content.removeAttribute('tabindex'),
          { once: true }
        );
      }

    });
  }
}

customElements.define('collection-description', CollectionDescription);


// --------------------------------------------------------   PRODUCT TABS SECTION -------------------------------------------------------------

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this._onTabClick = this._onTabClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  connectedCallback() {
    try {
      const root = this.querySelector('[data-section-tabs]') || this;
      this.tabButtons = Array.from(
        root.querySelectorAll('[data-tab-trigger]')
      );
      this.tabPanels = Array.from(
        root.querySelectorAll('[data-tab-panel]')
      );

      if (!this.tabButtons.length || !this.tabPanels.length) {
        console.warn('ProductTabs: No tabs or panels found');
        return;
      }

      this._setInitialState();
      this._attachEventListeners();
    } catch (error) {
      console.error('ProductTabs initialization error:', error);
    }
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  _attachEventListeners() {
    if (!this.tabButtons) return;
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this._onTabClick);
      button.addEventListener('keydown', this._onKeyDown);
    });
  }

  _removeEventListeners() {
    if (!this.tabButtons) return;
    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this._onTabClick);
      button.removeEventListener('keydown', this._onKeyDown);
    });
  }

  _setInitialState() {
    const activeButton =
      this.tabButtons.find((btn) =>
        btn.classList.contains('product-tabs__tab--active')
      ) || this.tabButtons[0];
    const activeId = activeButton?.dataset.tabTrigger;

    this.tabButtons.forEach((btn) => {
      const isActive = btn === activeButton;
      btn.classList.toggle('product-tabs__tab--active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.tabPanels.forEach((panel) => {
      const id = panel.dataset.tabPanel;
      const isActive = id === activeId;
      panel.classList.toggle('product-tabs__panel--active', isActive);
      panel.hidden = !isActive;
    });
  }

  _onTabClick(event) {
    const button = event.currentTarget;
    const targetId = button.dataset.tabTrigger;
    if (!targetId) return;

    this._activateTab(button, targetId);
  }

  _onKeyDown(event) {
    const currentIndex = this.tabButtons.indexOf(event.currentTarget);
    let nextIndex;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.tabButtons.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
        break;
      case 'Home':
        event.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        nextIndex = this.tabButtons.length - 1;
        break;
      default:
        return;
    }

    const nextButton = this.tabButtons[nextIndex];
    if (nextButton) {
      nextButton.focus();
      nextButton.click();
    }
  }

  _activateTab(button, targetId) {
    // Update tab buttons
    this.tabButtons.forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('product-tabs__tab--active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update tab panels
    this.tabPanels.forEach((panel) => {
      const id = panel.dataset.tabPanel;
      const isActive = id === targetId;
      panel.classList.toggle('product-tabs__panel--active', isActive);
      panel.hidden = !isActive;
    });

    // Smooth scroll on mobile
    this._scrollToPanel(targetId);
  }

  _scrollToPanel(targetId) {
    const activePanel = this.tabPanels.find(p => p.dataset.tabPanel === targetId);
    if (activePanel && window.innerWidth < 768) {
      setTimeout(() => {
        activePanel.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest' 
        });
      }, 100);
    }
  }
}

customElements.define('product-tabs', ProductTabs);


// ---------------------------------------------------  PRODUCT QUANTITY  -------------------------------------------------------------


class QuantitySelector extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Mark this element so Forms class can identify it
    this.setAttribute('data-web-component', 'true');
    
    this.init();
  }
  
  disconnectedCallback() {
    if (this.minusBtn) {
      this.minusBtn.removeEventListener('click', this.handleMinus);
    }
    if (this.plusBtn) {
      this.plusBtn.removeEventListener('click', this.handlePlus);
    }
  }
  
  init() {
    this.input = this.querySelector('[data-quantity-input]');
    this.minusBtn = this.querySelector('[data-quantity-minus]');
    this.plusBtn = this.querySelector('[data-quantity-plus]');
    
    if (!this.input) return;
    
    // Mark the wrapper inside so Forms class skips it
    const wrapper = this.querySelector('[data-quantity-wrapper]');
    if (wrapper) {
      wrapper.setAttribute('data-skip-forms', 'true');
    }
    
    this.handleMinus = this.handleMinus.bind(this);
    this.handlePlus = this.handlePlus.bind(this);
    
    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', this.handleMinus);
    }
    
    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', this.handlePlus);
    }
  }
  
  handleMinus(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setValue(this.getCurrentValue() - 1);
  }
  
  handlePlus(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setValue(this.getCurrentValue() + 1);
  }
  
  getCurrentValue() {
    const value = parseInt(this.input.value, 10);
    return Number.isNaN(value) ? 1 : value;
  }
  
  setValue(newValue) {
    const min = parseInt(this.input.min || '1', 10);
    const validMin = Number.isNaN(min) ? 1 : min;
    const safeValue = Math.max(newValue, validMin);
    this.input.value = safeValue;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}


// ----------------------------------------------------- Trigger CLICK on Cart Icon For the Rebuy ----------------------------------------------------------

document.addEventListener("rebuy:smartcart.ready", () => {
  // alert('Rebuy Activated');
  console.log('#####################################  REBUY SMART CART IS READY ###########################################33')
  document.querySelector('[data-rebuy-cart-open]').addEventListener('click', () => {
    Rebuy.SmartCart.show();
  });
});